import { render, staticRenderFns } from "./veSbzcZcPurchaseShow.vue?vue&type=template&id=5a8b05e7&scoped=true"
import script from "./veSbzcZcPurchaseShow.vue?vue&type=script&lang=js"
export * from "./veSbzcZcPurchaseShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b05e7",
  null
  
)

export default component.exports